import React, { useState } from 'react';
import axios from 'axios';
import { useSpring, animated } from '@react-spring/web';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import Cookies from "js-cookie";
const TicketStatus = () => {
  const [ticketNumber, setTicketNumber] = useState('');
  const [statusUpdates, setStatusUpdates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searched, setSearched] = useState(false);
const token = Cookies.get("token");
  const animationProps = useSpring({
    opacity: statusUpdates.length > 0 ? 1 : 0,
    transform: statusUpdates.length > 0 ? 'translateY(0)' : 'translateY(-20px)',
    config: { duration: 300 },
  });

  const dotAnimation = useSpring({
    from: { transform: 'translateY(-20px)' },
    to: { transform: 'translateY(0)' },
    config: { duration: 500 },
    reset: true,
  });

  const handleInputChange = (e) => {
    setTicketNumber(e.target.value);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  };

  const handleSearch = async () => {
    if (!ticketNumber) {
      setError('Please enter a ticket number.');
      return;
    }

    setLoading(true);
    setError('');
    setSearched(true);

    try {
      const response = await axios.get(`${API_BASE_URL}/TicketSearch/Search/${ticketNumber}`,
        { headers: { "Content-Type": "application/json" ,
          "Authorization": token ? `Bearer ${token}` : "",
        } });
      if (response.data.statusUpdates) {
        setStatusUpdates(response.data.statusUpdates);
      } else {
        setError('Ticket not found.');
      }
    } catch (err) {
      setError('An error occurred while fetching the ticket status.');
    } finally {
      setLoading(false);
    }
  };


  const makeLinksClickable = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
            {part}
          </a>
        );
      }
      return part;
    });
  };



  return (
    <div className="  pb-2 rounded-md">
      {searched && (
        <div>
          {loading && <p className="text-gray-700">Loading...</p>}
          {error && <p className="text-red-500">{error}</p>}

          {statusUpdates.length > 0 && (
            <animated.div className="text-left" style={{ ...animationProps }}>
              <div className="relative">
                <ul className="list-none p-0">
                  {statusUpdates.map((update, index) => (
                    <animated.li
                      key={index}
                      className="flex items-center pt-6 justify-between relative"
                      style={dotAnimation}
                    >
                      {/* Circle for active status */}
                      <div
                        className={`w-3 h-3 ml-1 rounded-full bg-green-500 absolute left-0 transform -translate-x-1/2 ${index === statusUpdates.length - 1 ? 'w-5 h-5' : ''
                          }`}
                      >
                        {index === statusUpdates.length - 1 && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-3 h-3 text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        )}
                      </div>

                      {/* Vertical line between circles */}
                      {index > 0 && (
                        <div className="absolute left-1 w-px h-full bg-green-500 transform -translate-y-2/4" />
                      )}

                      <span className="flex-1 text-left pl-8">
                        <strong>{makeLinksClickable(update.status)}</strong>
                      </span>
                      <span className="text-right">{formatDate(update.date)}</span>
                    </animated.li>
                  ))}
                </ul>
              </div>
            </animated.div>
          )}
        </div>
      )}


      {!searched && (
        <>
          <label className="text-[16px] mb-2">Ticket Number</label>
          <input
            type="text"
            value={ticketNumber}
            onChange={handleInputChange}
            placeholder="Enter your ticket number"
            className="p-3 w-full border mt-2 border-gray-300 rounded-md focus:ring-2 focus:text-[#1C50A3] focus:outline-none mb-4" // Increased bottom margin
          />
          <button
            onClick={handleSearch}
            className="py-3 px-6 bg-[#1C50A3] text-white font-semibold rounded-md shadow-lg hover:bg-[#3159a6] focus:ring-2 focus:ring-[#1C50A3] focus:outline-none transition-all duration-300 ease-in-out w-full"
          >
            Search
          </button>

        </>
      )}
    </div>
  );
};

export default TicketStatus;
